import { Input } from "antd";
import { PasswordProps } from "antd/es/input";
import EyeClosed from "../../assets/images/icons/EyeClosed";
import EyeOpen from "../../assets/images/icons/EyeOpen";
import LockKey from "../../assets/images/icons/LockKey";
import { InputPasswordType } from "./data";
import styles from "./styles.module.scss";

const CustomPassword: React.FC<PasswordProps & InputPasswordType> = ({
  showIcon = false,
  ...props
}) => {
  const eyeIconRender = (visible: boolean) => {
    return (
      <span className={styles.iconWrapper}>
        {visible ? <EyeOpen /> : <EyeClosed />}
      </span>
    );
  };

  return (
    <Input.Password
      addonBefore={showIcon ? <LockKey /> : null}
      {...props}
      iconRender={eyeIconRender}
    />
  );
};

export default CustomPassword;
